import React, { useEffect } from "react";
import { rideTerminate } from '@services/api';
import { useSelector, useDispatch } from "react-redux";
import * as actionTypes from "@redux/actionTypes";
import { safeLocalStorage } from "@utils/localstorage";
let timeColor = '#F2EB3A'

const CountdownTimer = ({ endTime }) => {
  const dispatch = useDispatch()
  const tournamentData = safeLocalStorage.getItem('tournamentData')
  const scanCheckPointList = useSelector((state) => state.testDriveDetails.scanCheckPointList)
  const allScanCheckpoint = useSelector((state) => state.testDriveDetails.allScanCheckpoint)
  const testDriveTimer = useSelector((state) => state.testDriveDetails.testDriveTimer)
  const user = useSelector((state) => state?.setUserDetails?.user)
  const testDriveRideId = useSelector((state) => state.testDriveDetails.testDriveRideId);

  const formatTime = (ms) => {
    const seconds = Math.floor((ms / 1000) % 60);
    const minutes = Math.floor((ms / 1000 / 60) % 60);
    const time = [minutes, seconds].map((v) => String(v).padStart(2, 0)).join(":");
    dispatch({
      type: actionTypes.TEST_DRIVE_TIMER,
      payload: time
    })
  };

  useEffect(() => {
    const interval = setInterval(async () => {
      if (endTime) {
        const currentTime = Date.now();
        const newRemainingTime = endTime - currentTime;
        if (newRemainingTime > 0) {
          formatTime(newRemainingTime);
        } else {
          dispatch({
            type: actionTypes.GPT_ERROR_TOAST,
            payload: false
          })
          dispatch({
            type: actionTypes.GPT_MESSAGE_TOAST,
            payload: false
          })
          await rideTerminate(testDriveRideId)
          clearInterval(interval);
          safeLocalStorage.removeItem(`agoratoken_${tournamentData?.deviceId}`)
          safeLocalStorage.removeItem(`keyBinding_${user?.id}`)
          safeLocalStorage.removeItem(`score_${user.id}`)
          safeLocalStorage.removeItem(`keyboradKey`)
          safeLocalStorage.removeItem(`WheelKey`)
          safeLocalStorage.removeItem(`RemoteKey`)
          safeLocalStorage.removeItem(`selectControllerName`)
          safeLocalStorage.removeItem(`tournamentData`)
          dispatch({
            type: actionTypes.TEST_DRIVE_COMPLECT,
            payload: true
          })
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [endTime]);

  useEffect(() => {
    if (scanCheckPointList?.length === 0 || allScanCheckpoint?.length === 0) {
      timeColor = '#FAFAFA'
    } else if ((scanCheckPointList?.length && allScanCheckpoint?.length && scanCheckPointList?.length === allScanCheckpoint?.length && scanCheckPointList?.length !== 0 && allScanCheckpoint?.length !== 0)) {
      timeColor = '#55F99B'
    }
  }, [scanCheckPointList, allScanCheckpoint])

  return (
    <div className='timer-container'>
      <p className="timer-number" style={{ color: timeColor }}>{testDriveTimer}</p>
      <p className="time-left-letter" style={{ color: timeColor }}>Time Left</p>
    </div>
  )
};

export default CountdownTimer;
